import { COMPARATOR_TYPES, Filter } from '~/searchApi';

import { CONTENT_SEARCH_AD_HASHTAGS } from './useContentSearch.constants';
import { IContentSearchQuery } from './useContentSearch.types';

export const getAdvertisementFilter = ({
  ads,
}: Partial<IContentSearchQuery>): Filter | void => {
  if (ads) {
    return {
      comparator: COMPARATOR_TYPES.CONTAINS,
      name: 'hashtags',
      value: CONTENT_SEARCH_AD_HASHTAGS,
    };
  }
};

export const getQueryFilter = ({ query }: Partial<IContentSearchQuery>) => {
  const hasthtagRegExp = new RegExp(/#\w+/g);
  const hashtags = query?.match(hasthtagRegExp);

  const mentionRegExp = new RegExp(
    /(^|\s)(@\w+)(\.\w+)?(\.\w+)?(\.\w+)?(\.\w+)?(\.\w+)?/g,
  );
  const mentions = query?.match(mentionRegExp);

  const result: {
    searchQuery?: string;
    hashtagFilter?: Filter;
    mentionFilter?: Filter;
  } = {};

  if (query) {
    result.searchQuery = query.replace(hasthtagRegExp, '').trim();
  }

  if (hashtags) {
    result.hashtagFilter = {
      comparator: COMPARATOR_TYPES.CONTAINS_ALL,
      name: 'hashtags',
      value: [...hashtags],
    };
  }

  if (mentions) {
    result.mentionFilter = {
      comparator: COMPARATOR_TYPES.CONTAINS_ALL,
      name: 'mentions',
      value: [...mentions],
    };
  }

  return result;
};
